/**
 * @fileoverview AI prompt data source with custom fields for model settings,
 * temperature, max tokens, and prompt key.
 */

import { AiPromptSchema, type AiPrompt } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { getCache } from './cache-registry';
import { FIELD_WIDTHS } from './constants';
import { createAuditFieldsWithArchive, createDisplayOrderField, createIdField, createJsonField, createNumberField, createStringField } from './field-factories';

export type { AiPrompt };

export const aiPromptDataSource = createBaseDataSource<AiPrompt>({
  endpoint: 'ai_prompt',
  searchField: 'title',
  schema: AiPromptSchema,
  fields: [
    createIdField(),
    createStringField('title', 'Title', FIELD_WIDTHS.LARGE),
    createStringField('content', 'Content', FIELD_WIDTHS.XLARGE),
    createStringField('prompt_key', 'Prompt Key', FIELD_WIDTHS.MEDIUM),
    createDisplayOrderField(),
    createStringField('model', 'Model', FIELD_WIDTHS.MEDIUM),
    createNumberField('temperature', 'Temperature'),
    createNumberField('max_tokens', 'Max Tokens'),
    createStringField('context', 'Context', FIELD_WIDTHS.XLARGE),
    createJsonField('metadata', 'Metadata'),
    ...createAuditFieldsWithArchive(),
  ],
});

export const aiPromptCache = getCache('ai_prompt');
